








import Vue from 'vue'
import CanvasContainer from './CanvasContainer.vue';
import PanelLeft from './PanelLeft.vue';
import PanelRight from './PanelRight.vue';

export default Vue.extend({
name: 'MainWrapper',

components: {
    CanvasContainer,
    PanelLeft,
    PanelRight
}
})
